module.exports = __webpack_public_path__ + "static/media/11.1c6a76ae.png";